import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-result-row-header.scss',
  tag: 'paf-result-row-header',
})

export class PafResultRowHeader implements ComponentInterface {

  /**
   * If a picto should be shown, define the name of it.
   * Example: picto-l1
   * [property of paf-icon]
   */
  @Prop() public picto?: string;

  /**
   * If a product icon should be shown, define the name of it.
   * Example: ic-80
   * [property of paf-icon]
   */
  @Prop() public productIcon?: string;

  /**
   * If a product text should be shown, define the name of it.
   * Example: B11
   */
  @Prop() public productText?: string;

  /**
   * The text to show
   */
  @Prop() public direction!: string;

  /**
   * If set to true, the component will show a loading skeleton
   */
  @Prop() public loading?: boolean;

  /**
   * The level the module is used on
   */
  @Prop() public level!: string;

  public render(): HTMLDivElement {
    const pictoIconVariant = `picto-l${this.level}` as 'picto-l1' | 'picto-l2';
    const productIconVariant = `product-l${this.level}` as 'product-l1' | 'product-l2';

    return (
      <div class={{
        loading: this.loading,
        wrapper: true,
        [`wrapper-l${this.level}`]: true,
      }}>

        {this.loading &&
          <div class='loader'></div>
        }

        {this.picto &&
          <paf-icon
            class={{
              'icon': true,
              'icon--picto': true,
              [`icon--picto-l${this.level}`]: true,
            }}
            name={this.picto}
            variant={pictoIconVariant}
          />
        }

        {this.productIcon &&
          <paf-icon
            class={{
              'icon': true,
              'icon--product': true,
              [`icon--product-l${this.level}`]: true,
            }}
            name={this.productIcon}
            variant={productIconVariant}
          />
        }

        {this.productText &&
          <span class='product-text'>{this.productText}</span>
        }

        <span class='text'>{this.direction}</span>
      </div>
    );
  }
}
